




export default function setupNews () {

    let loading = null;
    let offset = 2;

    function addContent () {
        const loader = document.querySelector('.news-overview .loader');

        if ( !loader ) {
            return;
        }

        if ( loader.getBoundingClientRect().top > window.innerHeight ) {
            return;
        }

        if ( !loading && loader.offsetParent !== null) {
            loading = fetch('/wp-admin/admin-ajax.php?action=get_news&offset='+offset)

            loading
                .then(r => r.text())
                .then(items => {
                    offset++;
                    if ( !items ) {
                        loader.remove();
                    } else {
                        loader.insertAdjacentHTML('beforebegin', items);
                    }

                    loading = null;
                });
        }
    }



    window.addEventListener('DOMContentLoaded', () => {
        const overview = document.querySelector('.news-overview');
        if ( !overview ) return;

        addContent();
        window.addEventListener('scroll', addContent);
    });
}
